import Vue from "vue";
import VueRouter from "vue-router";
const Home = () => import("../views/home/Home.vue"); //首页
const Login = () => import("../views/login/Login.vue"); //登录
// const Register = () => import('../views/register/register.vue') //注册
const Workbench = () => import("../views/workbench/workbench.vue"); //工作台
const Automationexpansion = () =>
  import(
    "../views/extendedmanagement/automationexpansion/automationexpansion.vue"
  );
const Processexpansion = () =>
  import("../views/extendedmanagement/processextension/processextension.vue");
const Thesaurusmanagement = () =>
  import("../views/dictionary/thesaurusmanagement/thesaurusmanagement.vue"); //词库管理
const Commentsearchtermmanagement = () =>
  import(
    "../views/dictionary/commentsearchtermmanagement/commentsearchtermmanagement.vue"
  ); //评论搜索词管理
const Sensitivewordmanagement = () =>
  import(
    "../views/dictionary/sensitivewordmanagement/sensitivewordmanagement.vue"
  ); //敏感词管理
const Userlist = () => import("../views/usermanagement/userlist/userlist.vue"); //用户列表
const Pctechnologicalprocess = () =>
  import(
    "../views/technologicalprocess/pctechnologicalprocess/pctechnologicalprocess.vue"
  ); //PC流程
const Androidtechnologicalprocess = () =>
  import(
    "../views/technologicalprocess/androidtechnologicalprocess/androidtechnologicalprocess.vue"
  ); //Android流程
const MemberRole = () =>
  import("../views/systemmanagement/memberRole/memberRole.vue"); //成员设置
const RoleSettings = () =>
  import("../views/systemmanagement/roleSettings/roleSettings.vue"); //角色设置
const Jigsawinterfacerecord = () =>
  import(
    "../views/datamanagement/jigsawinterfacerecord/jigsawinterfacerecord.vue"
  ); //拼图记录接口
const Userprocessoperation = () =>
  import(
    "../views/datamanagement/userprocessoperation/userprocessoperation.vue"
  ); //用户流程操作
const aitflows = () => import("../views/aitflow/list/index.vue"); // AIT流程列表
const aitflowOrders = () => import("../views/aitflow/order/index.vue"); // AIT流程列表
const aitflowUsers = () => import("../views/aitflow/user/index.vue"); // AIT流程列表
const aitflowFeedbacks = () => import("../views/aitflow/feedback/index.vue"); // 问题反馈
const promoUsers = () => import("../views/promo/user.vue");
const promoFlows = () => import("../views/promo/flow.vue");
const promoTasks = () => import("../views/promo/task.vue");
const promoTaskLogs = () => import("../views/promo/tasklogs.vue");
const promoSettings = () => import("../views/promo/setting.vue");
const promoDataset = () => import("../views/promo/dataset.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: "/home",
    name: "Home",
    component: Home,
    redirect: "/workbench",
    children: [
      {
        path: "/workbench",
        name: "Workbench",
        component: Workbench,
      },

      {
        path: "/automationexpansion",
        name: "Automationexpansion",
        component: Automationexpansion,
      },
      {
        path: "/processexpansion",
        name: "Processexpansion",
        component: Processexpansion,
      },
      {
        path: "/thesaurusmanagement",
        name: "Thesaurusmanagement",
        component: Thesaurusmanagement,
      },
      {
        path: "/commentsearchtermmanagement",
        name: "Commentsearchtermmanagement",
        component: Commentsearchtermmanagement,
      },
      {
        path: "/sensitivewordmanagement",
        name: "Sensitivewordmanagement",
        component: Sensitivewordmanagement,
      },
      {
        path: "/userlist",
        name: "Userlist",
        component: Userlist,
      },

      {
        path: "/pctechnologicalprocess",
        name: "Pctechnologicalprocess",
        component: Pctechnologicalprocess,
      },
      {
        path: "/androidtechnologicalprocess",
        name: "Androidtechnologicalprocess",
        component: Androidtechnologicalprocess,
      },

      {
        path: "/jigsawinterfacerecord",
        name: "Jigsawinterfacerecord",
        component: Jigsawinterfacerecord,
      },
      {
        path: "/userprocessoperation",
        name: "Userprocessoperation",
        component: Userprocessoperation,
      },

      {
        path: "/memberRole",
        name: "MemberRole",
        component: MemberRole,
      },
      {
        path: "/roleSettings",
        name: "RoleSettings",
        component: RoleSettings,
      },
      {
        path: "/ait-flow-list",
        name: "Aitflows",
        component: aitflows,
      },
      {
        path: "/ait-flow-order",
        name: "AitflowOrders",
        component: aitflowOrders,
      },
      {
        path: "/ait-flow-user",
        name: "AitflowUsers",
        component: aitflowUsers,
      },
      {
        path: "/ait-flow-feedback",
        name: "AitflowFeedbacks",
        component: aitflowFeedbacks,
      },
      {
        path: "/promo-users",
        name: "PromoUsers",
        component: promoUsers,
      },
      {
        path: "/promo-flows",
        name: "PromoFlows",
        component: promoFlows,
      },
      {
        path: "/promo-tasks",
        name: "PromoTasks",
        component: promoTasks,
      },
      {
        path: "/promo-task-logs",
        name: "PromoTaskLogs",
        component: promoTaskLogs,
      },
      {
        path: "/promo-settings",
        name: "PromoSettings",
        component: promoSettings,
      },
      {
        path: "/promo-dataset",
        name: "PromoDataset",
        component: promoDataset,
      },
    ],
  },
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.name == "login") return next();
  if (!sessionStorage.getItem("token")) {
    vm.$Message.error("您还没有登录，请先登录账户");
    next("/");
  }
  next();
});
export default router;
